import { useState, useEffect } from 'react';
import { BREAKPOINTS, getBreakpointName } from '../utils/viewport';

/**
 * 获取当前视口信息，用于 PC / 平板 / 移动端兼容
 * @returns {{
 *   width: number,
 *   height: number,
 *   isMobile: boolean,
 *   isTablet: boolean,
 *   isDesktop: boolean,
 *   breakpoint: string,
 *   isMobileOrTablet: boolean
 * }}
 */
export function useViewport() {
  const [viewport, setViewport] = useState(() => {
    if (typeof window === 'undefined') {
      return {
        width: 1024,
        height: 768,
        isMobile: false,
        isTablet: false,
        isDesktop: true,
        breakpoint: 'desktop',
        isMobileOrTablet: false,
      };
    }
    const w = window.innerWidth;
    const h = window.innerHeight;
    const breakpoint = getBreakpointName(w);
    return {
      width: w,
      height: h,
      isMobile: w < BREAKPOINTS.MOBILE,
      isTablet: w >= BREAKPOINTS.MOBILE && w < BREAKPOINTS.TABLET,
      isDesktop: w >= BREAKPOINTS.TABLET,
      breakpoint,
      isMobileOrTablet: w < BREAKPOINTS.TABLET,
    };
  });

  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;
      const breakpoint = getBreakpointName(w);
      setViewport({
        width: w,
        height: h,
        isMobile: w < BREAKPOINTS.MOBILE,
        isTablet: w >= BREAKPOINTS.MOBILE && w < BREAKPOINTS.TABLET,
        isDesktop: w >= BREAKPOINTS.TABLET,
        breakpoint,
        isMobileOrTablet: w < BREAKPOINTS.TABLET,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return viewport;
}
